// extracted by mini-css-extract-plugin
export default {"button":"toogle_button__1i8o+","slide":"toogle_slide__+9ewi"};